module.exports = __webpack_public_path__ + "img/菁英启航系统.883f5f4b.png";